import { render, staticRenderFns } from "./TaskAccessories.vue?vue&type=template&id=eced67ba&scoped=true"
import script from "./TaskAccessories.vue?vue&type=script&lang=js"
export * from "./TaskAccessories.vue?vue&type=script&lang=js"
import style0 from "./TaskAccessories.vue?vue&type=style&index=0&id=eced67ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eced67ba",
  null
  
)

export default component.exports